import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SupportChat } from "@/components/SupportChat";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { UserLayout, AdminLayout } from "@/components/PortalLayout";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import HowItWorks from "@/pages/public/HowItWorks";
import PlansPublic from "@/pages/public/PlansPublic";
import ReferralProgram from "@/pages/public/ReferralProgram";
import FAQ from "@/pages/public/FAQ";
import Contact from "@/pages/public/Contact";
import Legal from "@/pages/public/Legal";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import AdminLogin from "@/pages/auth/AdminLogin";

import Dashboard from "@/pages/user/Dashboard";
import PlansPortal from "@/pages/user/PlansPortal";
import Deposit from "@/pages/user/Deposit";
import Withdrawal from "@/pages/user/Withdrawal";
import Referrals from "@/pages/user/Referrals";
import Transactions from "@/pages/user/Transactions";
import Verification from "@/pages/user/Verification";
import Notifications from "@/pages/user/Notifications";
import Profile from "@/pages/user/Profile";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminDeposits from "@/pages/admin/AdminDeposits";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminInvestments from "@/pages/admin/AdminInvestments";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminTransactions from "@/pages/admin/AdminTransactions";
import AdminVerification from "@/pages/admin/AdminVerification";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAuditLogs from "@/pages/admin/AdminAuditLogs";

import SharesPublic from "@/pages/public/SharesPublic";
import Projects from "@/pages/public/Projects";
import SharesPortal from "@/pages/user/SharesPortal";
import MyShares from "@/pages/user/MyShares";
import MyShareDeposits from "@/pages/user/MyShareDeposits";
import ShareConfirmation from "@/pages/user/ShareConfirmation";
import AdminShares from "@/pages/admin/AdminShares";
import AdminShareDeposits from "@/pages/admin/AdminShareDeposits";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminCharity from "@/pages/admin/AdminCharity";

const U = (C) => <ProtectedRoute><UserLayout>{C}</UserLayout></ProtectedRoute>;
const A = (C) => <ProtectedRoute adminOnly><AdminLayout>{C}</AdminLayout></ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/plans" element={<PlansPublic />} />
          <Route path="/referral-program" element={<ReferralProgram />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/risk-disclosure" element={<Legal page="risk" />} />
          <Route path="/withdrawal-policy" element={<Legal page="withdrawal" />} />
          <Route path="/kyc-policy" element={<Legal page="kyc" />} />
          <Route path="/shares" element={<SharesPublic />} />
          <Route path="/projects" element={<Projects />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* User portal */}
          <Route path="/dashboard" element={U(<Dashboard />)} />
          <Route path="/plans-portal" element={U(<PlansPortal />)} />
          <Route path="/deposit" element={U(<Deposit />)} />
          <Route path="/withdrawal" element={U(<Withdrawal />)} />
          <Route path="/referrals" element={U(<Referrals />)} />
          <Route path="/transactions" element={U(<Transactions />)} />
          <Route path="/verification" element={U(<Verification />)} />
          <Route path="/notifications" element={U(<Notifications />)} />
          <Route path="/profile" element={U(<Profile />)} />
          <Route path="/shares-portal" element={U(<SharesPortal />)} />
          <Route path="/my-shares" element={U(<MyShares />)} />
          <Route path="/my-share-deposits" element={U(<MyShareDeposits />)} />
          <Route path="/share-confirmation/:kind/:id" element={U(<ShareConfirmation />)} />

          {/* Admin portal */}
          <Route path="/admin" element={A(<AdminDashboard />)} />
          <Route path="/admin/users" element={A(<AdminUsers />)} />
          <Route path="/admin/users/:id" element={A(<AdminUserDetail />)} />
          <Route path="/admin/deposits" element={A(<AdminDeposits />)} />
          <Route path="/admin/withdrawals" element={A(<AdminWithdrawals />)} />
          <Route path="/admin/investments" element={A(<AdminInvestments />)} />
          <Route path="/admin/referrals" element={A(<AdminReferrals />)} />
          <Route path="/admin/transactions" element={A(<AdminTransactions />)} />
          <Route path="/admin/verification" element={A(<AdminVerification />)} />
          <Route path="/admin/plans" element={A(<AdminPlans />)} />
          <Route path="/admin/settings" element={A(<AdminSettings />)} />
          <Route path="/admin/audit-logs" element={A(<AdminAuditLogs />)} />
          <Route path="/admin/shares" element={A(<AdminShares />)} />
          <Route path="/admin/share-deposits" element={A(<AdminShareDeposits />)} />
          <Route path="/admin/projects" element={A(<AdminProjects />)} />
          <Route path="/admin/charity" element={A(<AdminCharity />)} />
        </Routes>
        <SupportChat />
      </BrowserRouter>
    </div>
  );
}

export default App;
